import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import image from '../assets/images/no-image.jpg';
import Isvg from 'react-inlinesvg';
import cart_icon from '../assets/svg/cart-icon.svg'

function generateAlias(str) {
    str = str.toLowerCase();
    str = str.replace(/\s\s+/g, ' ');
    str = str.replace(/ /g, '-');
    str = str.replace(/\./g, '-');
    str = str.replace(/\,/g, '-');
    str = str.replace(/š/g, 's');
    str = str.replace(/č/g, 'c');
    str = str.replace(/ć/g, 'c');
    str = str.replace(/đ/g, 'dj');
    str = str.replace(/ž/g, 'z');
    str = str.replace(/\//g, '-');

    return str;
}


export class Article extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }


    render() {
        return (

            <article className={this.props.listView ? 'article article-list' : 'article'}>

                <Link to={`/product/${generateAlias(this.props.title ? this.props.title : ' ')}/${this.props._id}`}> <img onError={() => { this.setState({ imageError: true }) }} src={!this.state.imageError ? this.props.image ? this.props.image : image : image} /></Link>
                <div className="title-wrap">
                    <Link to={`/product/${generateAlias(this.props.title ? this.props.title : ' ')}/${this.props._id}`}><h6>{this.props.title}</h6></Link>
                    <Link to={`/product/${generateAlias(this.props.title ? this.props.title : ' ')}/${this.props._id}`}><p className="alias">{this.props.alias}</p></Link>

                    {
                        this.props.listView ?
                            <p className="shortDescription">{this.props.shortDescription}</p>
                            :

                            null
                    }
                </div>
                <div className="bottom-wrap">
                    {this.props.package && this.props.package[0] && this.props.package[0].price ? <p>
                        {this.props.package[0].price.formatPrice(this.props.currency)}
                    </p>

                        : null}
                    <button onClick={() => this.props.addToCart()}><Isvg src={cart_icon} /> <span>KUPI</span></button>
                </div>
                {/*this.props.inStock ? <span className="in-stock">
                            {this.props.translate('Dostupno')}
                </span> : null*/}
            </article>

        )
    }
}

export default Article;